<template>
    <div class="navWrap">
        <div v-for="(item) in categoryData" :key="item.id" class="clearfix navBox" :style="{backgroundImage:'url(' + item.icon + ')'}">
            <div class="navContent clearfix fl" @click="toCategory1(item)">
                <div class="title fl"><i :class="item.icon"></i>
                {{ item.name }}</div>
                <i class="el-icon-arrow-right"></i>
            </div>
            <div class="right_menu">
                <div class="content clearfix">
                    <div class="right">
                        <span v-for="(itemRightMenuText,key) in item.child" :key="key">
                            <span class="item" @click="toCategory2(itemRightMenuText)"><i v-if="itemRightMenuText.icon" :class="itemRightMenuText.icon"></i>{{ itemRightMenuText.name }}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },
    computed: {
        categoryData() {
            return this.$store.state.shop_index.indexCategory;
        },
    },
    methods: {
        toCategory1(data) {
            this.$router.push({path: '/drugCategory',  query: { category_id: data.id } });
        },
        toCategory2(data) {
            this.$router.push({path: '/drugCategory',  query: { cat_id: data.id } });
        }
    }
}
</script>
<style lang="scss" scoped>
    .navWrap{
        position: absolute;
        top: 42px;
        z-index: 6;
        height: 434px;
        width: 200px;
        background: #2b2b2b;
        opacity: 0.8;
        color: #fff;
        cursor: pointer;
        text-indent: 0;
        font-weight: 700;
        box-shadow: 8px 0 7px -3px rgba(0,0,0,.3)
    }
    .navWrap:hover{
        opacity: 0.9;
    }
    .navWrap .navBox{
        background-position: 10px center;
        background-repeat: no-repeat;
        border-top: 1px solid #333;
        border-bottom: 1px solid #252525;
        height: 40px;
    }
    .navBox:hover {
        background-color: #ffffff;
        color: #333;
        // background-image: 
        .right_menu {
            display: block;
        }
    }
    .navWrap .navContent{
        width: 100%;
        height: 41px;
        margin-left: 20px;
        display: flex;
        align-items: center;
        position: relative;
        .el-icon-arrow-right{
            color: rgb(155, 155, 155);
            position:absolute;
            right: 30px;
            top: 15px;
        }
    }
    .navWrap .title{
        font-size: 14px;
        text-align: left;
        i{
          width: 20px;
          height:20px;
          display:inline-block;
          margin-right: 5px;
          font-size:20px;
        }
    }
    .navWrap .classification div{
        font-size: 14px;
        margin-right: 7px;
        margin-top: 2px;
    }
    .right_menu{
        position: absolute;
        display: none;
        top: 0;
        margin-left: 200px;
        z-index: 10;
        padding-left: 20px;
        width: 600px;
        height: 432px;
        border: 1px solid #e3e2e1;
        background: #fff;
    }
    .right_menu .content{
        display: flex;
        height: 40px;
        line-height: 40px;
        margin-top: 15px;
    }
    .right_menu .content .title{
        height: 40px;
        color: #333;
        margin-left: 15px;
        display: flex;
        align-items: center;
        margin-top: 0;
    }
    .right_menu .content .right{
        color: #666;
        width: 500px;
        display: flex;
        flex-wrap: wrap;
        height: 20px;
        line-height: initial;
        align-items:center ;
        margin-top: 0;
        display: flex;
    }
    .right_menu .content .right span{
        width: 24%;
        margin: 8px 0;
        font-size: 14px;
        font-weight: 500;
        color: #000;
        margin-left: 5px;
    }
    .right_menu .content .right span .item:hover{
        color: rgb(46, 152, 213);
    }
    .right_menu .content .title:hover{
        color: rgb(46, 152, 213);
    }
</style>